<template>
  <div>
    <div>
      <span
        v-if="soldMembership && soldMembership.membership_program_name"
        class="link"
        @click="toggleMembershipModal"
        >{{ soldMembership.membership_program_name }}</span
      >
      <span v-else> -- </span>
    </div>
    <CreateMembershipReplaceModal
      v-if="membershipModal"
      :customer="customer"
      :membership="membership"
      :sold-membership="soldMembership"
      :work-item-id="workItemId"
      @hide-modal="toggleMembershipModal"
      @save-success="refreshTable"
    />
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import CreateMembershipReplaceModal from "@/MembershipModal/CreateMembershipReplaceModal.vue";

export default {
  components: {
    CreateMembershipReplaceModal
  },
  props: {
    soldMembership: {
      type: Object,
      default: null
    },
    membership: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    workItemId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      membershipModal: false
    };
  },
  methods: {
    toggleMembershipModal() {
      this.membershipModal = !this.membershipModal;
    },
    refreshTable() {
      EventBus.$emit("refresh-datatable");
    }
  }
};
</script>

<style lang="scss" scoped></style>
